import React from "react";
import { PickersDay as MuiPickersDay } from "@mui/x-date-pickers/PickersDay";

function PickersDay(props) {
  return <MuiPickersDay {...props} />;
}

export default PickersDay;
